import React from "react"
import { FormattedMessage, useIntl } from "react-intl"
import {
  Box,
  Link,
  Tile,
  Typography,
  Stack,
  IconWithBackground,
  MessageSquareMoreIcon
} from "@carrotfertility/carotene-core"
import { Link as RouterLink } from "react-router-dom"

export function HomepageHelp(): JSX.Element {
  const intl = useIntl()
  return (
    <Tile
      variant="secondary"
      color="green"
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
      }}
    >
      <Stack gap={(theme) => theme.tokens.spacing.md}>
        <Typography variant="h5" marginBottom={(theme) => theme.spacing(theme.tokens.spacing.xs)}>
          <FormattedMessage defaultMessage="Can we help?" />
        </Typography>
        <Stack flexDirection="row" gap={(theme) => theme.tokens.spacing.md} alignItems="center">
          <IconWithBackground icon={MessageSquareMoreIcon} color="green" />
          <Typography variant="body1" color={(theme) => theme.palette.text.secondary}>
            <FormattedMessage defaultMessage="If you have questions about finding the right provider, how to advocate for yourself, or anything else, reach out to the Care Team." />
          </Typography>
        </Stack>
        <Box display="flex" alignItems="center">
          <Link
            component={RouterLink}
            color="inherit"
            to="/talk-to-carrot/sendmessage/helpfindingprovider"
            title={intl.formatMessage({ defaultMessage: "Contact your Care team for help finding a provider" })}
          >
            <FormattedMessage defaultMessage="Contact us" />
          </Link>
        </Box>
      </Stack>
    </Tile>
  )
}
